import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useRef, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IoTriangleOutline } from "react-icons/io5";
import { GrEmptyCircle } from "react-icons/gr";
import { FaStopCircle, FaPlayCircle } from "react-icons/fa";
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function ModuleListening() {
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [timer, setTimer] = useState(0); // Start timer from 0
    const [activePage, setActivePage] = useState("Learning");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // Disable submit initially
    const navigate = useNavigate();
    const [showResultButtons, setShowResultButtons] = useState(false); // Control when to show the new buttons
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null); // Track whether the answer is correct
    const [explanation, setExplanation] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const authToken = localStorage.getItem("AuthToken");
    const { Translate } = useContext(ProductContext);
    const [sound, setSound] = useState(null);
    // const [selectedOption, setSelectedOption] = useState(null);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [soundPlayed, setSoundPlayed] = useState(false);
    const soundRef = useRef(null);
    const audioRef = useRef(null);
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const swingAnimRef = useRef();

    const categoryData = location.state; // Receive the state passed during navigation
    const category_id = categoryData?.category_id;
    const categoryName = categoryData?.categoryName; // Match property name
    const level_id = categoryData?.level_id;
    const [loading, setLoading] = useState(false);
    console.log(
        "Received category data:",
        category_id,
        categoryName,
        level_id,
    );
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = await localStorage.getItem('selectedLanguage');
                setLanguage(storedLanguage || 'english');
            } catch (error) {
                console.error('Error loading language:', error);
            }
        };

        loadLanguage();
    }, []);


    useEffect(() => {
        fetchQuizData(currentPage);
    }, [currentPage]);


    const togglePlayPause = async (audioUrl) => {
        if (!audioRef.current) {
            // Initialize the audio if it doesn't exist
            audioRef.current = new Audio(audioUrl);
            audioRef.current.onended = () => setIsPlaying(false); // Reset state when audio ends
        }

        if (isPlaying) {
            audioRef.current.pause(); // Pause the audio
        } else {
            audioRef.current.play(); // Play the audio
        }
        setIsPlaying(!isPlaying); // Toggle the play/pause state
    };

    const stopAudio = () => {
        if (audioRef.current) {
            audioRef.current.pause(); // Stop playback
            audioRef.current.currentTime = 0; // Reset to the beginning
            setIsPlaying(false); // Update the state
        }
    };

    const handlePlayAudio = async (audioUrl) => {
        try {
            await togglePlayPause(audioUrl);
        } catch (error) {
            console.log("Error playing sound: ", error);
        }
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            // Stop audio when component unmounts
            stopAudio();
        };
    }, []);


    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // console.log("this is the category name and id ", categoryName, category_id)

    const fetchQuizData = async (page) => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `https://api.japaking.online/api/categories/${category_id}?page=0&size=6`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            console.log('API Response:', response.data); // Debugging

            if (response.data.success) {
                const newQuestions = response.data.message?.category?.questions || [];

                setQuizData((prevData) => [
                    ...prevData,
                    ...newQuestions.filter(
                        (q) => !prevData.some((p) => p.question_id === q.question_id)
                    ),
                ]);

                if (newQuestions.length < 6) {
                    setHasMoreQuestions(false);
                }
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log("navigate to login due to 401");
                navigate("Login");
            }
            console.error('Error fetching quiz data:', err); // Better error logging
        } finally {
            setIsLoading(false);
        }
    };


    const handleSelect = optionId => {
        setSelectedOption(optionId);
        setShowSelectAnswerMessage(false);
    };


    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            optionId: selectedOption,
            attemptStatus: selectedOptionData
                ? selectedOptionData.is_correct
                    ? 'correct'
                    : 'incorrect'
                : null,
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
    };

    const [showSelectAnswerMessage, setShowSelectAnswerMessage] = useState(false);

    const handleSubmit = async () => {
        if (!selectedOption) {
            setShowSelectAnswerMessage(true); // Show message if no option is selected
            return;
        }

        await submitUserAttempt(); // Submit the user attempt to the backend

        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );

        // Update the correctness and show the result buttons
        const answerCorrect = selectedOptionData?.is_correct || false;
        setIsCorrect(answerCorrect);
        setShowResultButtons(true); // Show the result buttons
        setIsSubmitted(true);
    };

    const handleNextQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        } else if (hasMoreQuestions && quizData.length > 0) {
            setCurrentPage(nextPage => nextPage + 1);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        } else {
            navigate('/thank-you-quiz', {
                categoryId: category_id,
                total_time_spent: timeSpent,
            });
        }
    };

    // const handleStartNewQuiz = () => {

    //   if (currentQuestionIndex < quizData.length - 1) {
    //     setCurrentQuestionIndex(currentQuestionIndex + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   } else if (hasMoreQuestions) {
    //     setCurrentPage(nextPage => nextPage + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   }
    // };


    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;
    const progressPercentage = (currentQuestionIndex + 1) / quizData.length;

    if (isLoading) {
        // return (
        //     <View style={styles.LoadingImageDiv}>
        //         <Image source={LoadingImage} style={styles.LoadingImageCss} />
        //     </View>
        // );
    }
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    // console.log("This si tiem spend ", timeSpent)

    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            navigate('/ListeningQuiz', {
                category_id: category_id,
            });
        } else {
            navigate('/thank-you-quiz', {
                category_id: category_id,
            });
        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        console.log('CURRENT QUESTION INDEX ', currentQuestionIndex);
        console.log('QUIZ DATA LENGTH ', quizData.length);
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else {
            console.log('i am here in else ');
            navigate('/thank-you-quiz', {
                categoryId: category_id,
                total_time_spent: timeSpent,
            });
        }
    };

    const handleSkip = async () => {
        // Ensure `currentQuestion` is defined
        const currentQuestion = quizData[currentQuestionIndex];
        if (!currentQuestion || !currentQuestion.options) {
            console.error("Current question or options are undefined");
            return;
        }

        // Find the selected option (if options exist)
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );

        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 'un_attempt'
        };

        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            setAttemptStatus(response?.data?.message?.attempt?.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log("navigate to login due to 401");
                navigate("Login");
            }
            console.error("Error submitting user attempt:", err);
        }

        handleNextQuestion();
    };

    const handleSureMove = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 'confirm',
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
            setShowResultButtons(false);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
        handleNextQuestion();
    };

    const handeReattempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 're_attempt',
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
            setShowResultButtons(false);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
        handleNextQuestion();
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => prevTimer + 1);
        }, 1000);

        return () => clearInterval(interval); // Clean up on unmount
    }, []);

    // const formatTime = (timeInSeconds) => {
    //     const minutes = Math.floor(timeInSeconds / 60);
    //     const seconds = timeInSeconds % 60;
    //     return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    // };

    const handleOptionClick = (index) => {
        setSelectedOption(index); // Set the selected option
        setIsSubmitDisabled(false); // Enable the submit button
    };

    // const handleNextQuestion = () => {
    //     setSelectedOption(null); // Clear selected option
    //     setIsCorrect(null); // Reset correct/incorrect display
    //     setIsSubmitDisabled(true); // Disable the submit button for the next question
    //     setShowResultButtons(false); // Hide the result buttons (Submit/Skip should be visible)

    //     if (currentQuestion < questions.length - 1) {
    //         setCurrentQuestion(currentQuestion + 1); // Move to the next question
    //     } else {
    //         // Navigate to ThankYouQuiz page when the quiz is completed
    //         navigate('/thank-you-quiz');
    //     }
    // };

    // const handleSubmitAnswer = () => {
    //     if (selectedOption !== null) {
    //         const correct = selectedOption === questions[currentQuestion].correct;
    //         setIsCorrect(correct);
    //         setIsAnswerCorrect(correct);
    //         setShowResultButtons(true);
    //         setIsSubmitted(true);
    //         // Map options and explanations
    //         const explanationArr = questions[currentQuestion].options.map((option, index) => ({
    //             option,
    //             explanation: questions[currentQuestion].explanations[index]
    //         }));
    //         setExplanation(explanationArr);

    //         setIsSubmitDisabled(true); // Disable submit button after submitting
    //     }
    // };


    // Toggle play/pause functionality
    // const togglePlayPause = () => {
    //     if (isPlaying) {
    //         audioRef.current.pause(); // Pause the audio
    //     } else {
    //         audioRef.current.play(); // Play the audio
    //     }
    //     setIsPlaying(!isPlaying); // Toggle the play/pause state
    // };
    // const progressWidth = ((currentQuestion + 1) / questions.length) * 100;
    useEffect(() => {
        if (!isLoading && quizData.length === 0) {

            navigate("/coming-soon");
        }
    }, [isLoading, currentQuestion, navigate]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{showResultButtons
                                ? Translate?.message?.data?.quizResult || "Quiz Result"
                                : Translate?.message?.data?.listeningQuiz || "Listening Quiz"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div
                                className={`quiz-container ${isSubmitted ? "left" : ""}`}
                            >
                                <div className="quiz-header">
                                    <div className="quiz-info">
                                        <span>{currentQuestionIndex + 1}/{quizData.length}</span>
                                    </div>
                                    <div className="quiz-timer">
                                        <span>{formatTime(timeSpent)}</span>
                                    </div>
                                </div>
                                <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
                                    <div
                                        className="progress-bar"
                                        style={{
                                            width: `${progressPercentage}%`,
                                            backgroundColor: '#ffc0cb',
                                            height: '100%',
                                            borderRadius: '5px',
                                        }}
                                    ></div>
                                </div>



                                <div className="quiz-question">
                                    <div className="quiz-header">
                                        <h6>{Translate?.message?.data?.selectTheCorrectTranslation || "Select the correct translation"}</h6>
                                    </div>
                                    <div className="quiz-question-container">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                        <div className="quiz-question-box">
                                            {isSubmitted ? (
                                                // Show question text after submission
                                                <h7>{currentQuestion?.question_text || "Question text not available"}</h7>
                                            ) : (
                                                // Show play/pause button before submission
                                                <p
                                                    onClick={() => currentQuestion?.url && handlePlayAudio(currentQuestion.url)}
                                                    style={{ fontWeight: "500", fontSize: "20px" }}
                                                >
                                                    {isPlaying ? (
                                                        <FaStopCircle size={40} color="#ffc0cb" />
                                                    ) : (
                                                        <FaPlayCircle size={40} color="#ffc0cb" />
                                                    )}
                                                </p>
                                            )}

                                        </div>
                                    </div>
                                </div>

                                <div className="quiz-options-container">
                                    <div className="quiz-options">
                                        {currentQuestion?.options?.length > 0 ? (
                                            currentQuestion.options.map((option) => (
                                                <button
                                                    key={option.option_id}
                                                    className={`quiz-option ${selectedOption === option.option_id
                                                        ? isSubmitted && isCorrect === true
                                                            ? 'correct' // Apply correct class if the option is correct
                                                            : isSubmitted && isCorrect === false
                                                                ? 'incorrect' // Apply incorrect class if the option is incorrect
                                                                : 'selected' // Apply selected class if the option is selected
                                                        : ''
                                                        }`}
                                                    onClick={() => handleSelect(option.option_id)}
                                                    disabled={isSubmitDisabled && selectedOption !== null} // Disable options after submitting
                                                >
                                                    <span
                                                        className={`quiz-option-text ${selectedOption === option.option_id
                                                            ? 'selected-text' // Apply selected-text class if the option is selected
                                                            : ''
                                                            }`}
                                                    >
                                                        {option.option_text || 'Option'} {/* Fallback text for option */}
                                                    </span>

                                                    {/* Feedback messages displayed only after submission */}
                                                    {isSubmitted && selectedOption === option.option_id && isCorrect === false && (
                                                        <span className="responsive-incorrect">
                                                            <CloseIcon className="quiz-close-icon" />
                                                            {Translate?.message?.data?.incorrect || "Incorrect"}
                                                        </span>
                                                    )}

                                                    {isSubmitted && selectedOption === option.option_id && isCorrect === true && (
                                                        <span className="responsive-correct">
                                                            <RadioButtonUncheckedIcon
                                                                className="quiz-checked-icon"
                                                            />
                                                            {Translate?.message?.data?.correct || "Correct"}
                                                        </span>
                                                    )}
                                                </button>
                                            ))
                                        ) : (
                                            <p>No options available</p> // Fallback UI for no options
                                        )}
                                        {showSelectAnswerMessage && (
                                            <h7 style={{
                                                color: 'red',
                                                marginTop: 5,
                                                textAlign: 'left', // Align the text to the right
                                            }}>
                                                {Translate?.message?.data?.pleaseSelectAnAnswer || " Please select an answer."}
                                            </h7>
                                        )}
                                    </div>
                                </div>
                                <div className="quiz-controls">
                                    <div className="quiz-buttons">
                                        {showResultButtons ? (
                                            isCorrect ? (
                                                <>
                                                    {/* Explanation Box */}
                                                    <div className="quiz-content">
                                                        <div className={`explanation-box ${!currentQuestion?.options?.[0]?.option_description ? 'hidden' : ''}`}>
                                                            {currentQuestion?.options?.[0]?.option_description && (
                                                                <>
                                                                    <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>
                                                                    {currentQuestion?.options?.map((option, i) => (
                                                                        <div key={i} className="explanation-item">
                                                                            <span>{option?.option_description}</span>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            )}
                                                        </div>


                                                        {/* Buttons for Correct Answer */}
                                                        <div
                                                            className={`result-buttons-correct ${!currentQuestion?.options?.[0]?.option_description ? 'no-explanation' : ''
                                                                }`}
                                                        >

                                                            <button className="quiz-submit" onClick={handleSureMove}>
                                                                {Translate?.message?.data?.dontWantToReattempt || "Don’t Want to Reattempt"}
                                                                <div className="reattempt-icon">
                                                                    <GrEmptyCircle size={20} color="white" />
                                                                </div>
                                                            </button>
                                                            <button className="quiz-submit" onClick={handeReattempt}>
                                                                {Translate?.message?.data?.wantToReattempt || "Want to Reattempt"}
                                                                <div className="want-reattempt-icon">
                                                                    <IoTriangleOutline size={20} color="white" />
                                                                </div>
                                                            </button>



                                                            <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                                {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                            </button>
                                                            <button className="quiz-submit" onClick={() => navigate("/")}>
                                                                {Translate?.message?.data?.backToHome || "Back to Home"}
                                                            </button>

                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Explanation Box */}
                                                    {currentQuestion?.options?.[0]?.option_description && (
                                                        <div className="explanation-incorect-box">
                                                            <>
                                                                <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>
                                                            </>
                                                            {currentQuestion?.options?.map((option, i) => (
                                                                <div key={i} className="explanation-item">
                                                                    <span>{option?.option_description}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {/* Buttons for Incorrect Answer */}
                                                    <div className="result-buttons-incorrect">

                                                        <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                            {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                        </button>

                                                        <button className="quiz-submit" onClick={() => navigate("/")}>
                                                            {Translate?.message?.data?.backToHome || "Back to Home"}
                                                        </button>

                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                {/* Initial Buttons */}
                                                <div>
                                                    {loading ? (
                                                        // Show a loading state for the button
                                                        <button
                                                            className="quiz-submit"
                                                            style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                            disabled
                                                        >
                                                            Loading...
                                                        </button>
                                                    ) : (
                                                        <>
                                                            {currentQuestion?.length >= 6 ? (
                                                                // Render the button without any action if the condition is met
                                                                <>

                                                                    <button
                                                                        className="quiz-submit"
                                                                        style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                        disabled
                                                                    >
                                                                        {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                    </button>

                                                                </>
                                                            ) : (
                                                                // Render the button with the onClick handler for skipping
                                                                <>

                                                                    <button
                                                                        className="quiz-submit"
                                                                        onClick={handleSkip}
                                                                        style={{ backgroundColor: "White" }}
                                                                    >
                                                                        {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                    </button>

                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                <div>

                                                    <button className="quiz-submit" onClick={() => handleSubmit()}>
                                                        {Translate?.message?.data?.submit || "Submit"}
                                                    </button>

                                                </div>
                                            </>
                                        )}


                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <Footer />
    </div>
  );
}
export default ModuleListening;
